"use strict";

/**
* Детальный набор данных.
* 
* @class WebAccess.components.wrappers.details.Detail
* @extends BaseObject
* @property {string} name Номер набора данных
* @property {string} tableName DFM-имя элемента управления таблицы
* @param {string} itemSelector Существующий элемент страницы
*/
(function (global) {

  var Detail = BaseObject.extend({
    _useTable: null,
    _jTables: null,
    _current: null,

    init: function (itemSelector, opt_params) {
      this._super(itemSelector);
      if (opt_params) this._current = opt_params.current;

      this._jObject = $(itemSelector);
      this.name = this._jObject.data('detailSectionNumber');
      this.tableName = this._jObject.attr('id');
      this._jTables = $('.Reference_Detail').filter('[data-detail-section-number=' + this.name + ']');
    },

    className: 'Detail',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
    * Определяет таблицу, с которой связан детальный раздел
    * @function WebAccess.components.wrappers.details.Detail#useTable
    * @return WebAccess.components.wrappers.details.Detail.
    * @since 5.0.2.1301
    */
    useTable: function(tableName) {
      this._useTable = tableName;
      return this;
    },

    /**
    * Добавление новой записи в детальный раздел. (Если можно, избегайте пока использование этой функции, 
    * очень велика вероятность, что её поведение кардинально изменится в будущем);
    * @function WebAccess.components.wrappers.details.Detail#append
    * @return WebAccess.components.wrappers.details.Detail
    */
    append: function () {
      var tableName = this._useTable || this.tableName;
      this._current.form.controls.tables[tableName].addRow();
      return this;
    },


    /**
    * Получить все записи детального раздела.
    * @function WebAccess.components.wrappers.details.Detail#getRecords
    * @return {WebAccess.components.wrappers.form.TableRow} Oбъект класса TableRow.
    */
    getRecords: function () {
      var tableName = this._useTable || this.tableName;
      return this._current.form.controls.tables[tableName].getRows();
    },


    /**
    * Получает таблицу, связанную с данным детальным разделом. 
    * @function WebAccess.components.wrappers.details.Detail#getTable
    * @param {string} [opt_tableName] Имя таблицы
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    * @since 5.2.0.1303
    */
    getTable: function (opt_tableName) {
      var tableName = opt_tableName || this._useTable || this.tableName;
      return this._current.form.controls.tables[tableName];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает все таблицы данного детального раздела.
    * @function WebAccess.components.wrappers.details.Detail#getTables
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table.
    * @since 5.2.0.1303
    */
    getTables: function () {
      var me = this;
      var tables = new WA.Collection();
      
      $(this._jTables).each(function (el) {
        var name = $(this).attr('id');
        var table = me._current.form.controls.tables[name];
        if (typeof table !== 'undefined')
          tables.addElement(name, table);
      });
      return tables;
    }
  });

  global.Detail = Detail;
})(window.WebAccess.components.wrappers.details);